/**
 * These are the event names sent to Mixpanel. For tracking reasons,
 * do not remove or rename any of the event names.
 */
export default Object.freeze({
  auth: {
    COMPLETE_REGISTRATION: 'Complete Registration',
    CONFIRM_ACCOUNT: 'Confirm Account',
    CONFIRM_NEW_PASSWORD: 'Confirm New Password',
    REGEN_API_KEY: 'Regen API Key',
    RESEND_CONFIRMATION_CODE: 'Resend Confirmation Code',
    RESET_PASSWORD: 'Reset Password',
    SIGN_IN: 'Sign In',
    SIGN_OUT: 'Sign Out',
    UPDATE_PROFILE: 'Update Profile',
  },
  interaction: {
    BUTTON_CLICKED: 'Button Clicked',
  },
  navigation: {
    PAGE_VIEW: 'Page View',
  },
  onboarding: {
    COPY_API_KEY: 'Copy API Key',
  },
});
